/**
 * Nút trên MỖI thẻ gói ở hồ sơ khách (phát hiện 27/10 #3): nút nào hiện khi nào, một nguồn để test.
 *
 * ADR-074 — "Tặng buổi" tạo THÊM giá trị cho khách nên đứng sau công tắc Gói và ví (máy chủ trả 403 khi tắt:
 * `POST /v1/admin/goi/:id/tang-buoi`). Tắt thì nút ẨN HẲN, không để chủ bấm ra lỗi. Các đường lấy tiền / buổi của khách
 * RA (gia hạn, huỷ số dư cũ, hoàn gói) vẫn chạy khi tắt — tiền của khách không bị giam bởi một công tắc.
 */
export interface NutGoiVao {
  /** Công tắc `goi-vi` của tiệm đang bật. */
  batGoiVi: boolean
  /** Người xem được phép sửa sổ (chủ / quản lý). */
  choHoan: boolean
  laChu: boolean
  /** Gói nhập từ số dư cũ. */
  soCu: boolean
  sessionsUsed: number
  /** `'da-dong'` = gói đã đóng (hết sạch / hoàn) → không còn nút nào. */
  trangThai: string
}

export interface NutGoiRa {
  tangBuoi: boolean
  giaHan: boolean
  huySoCu: boolean
  hoanGoi: boolean
}

export function nutGoi(v: NutGoiVao): NutGoiRa {
  const mo = v.choHoan && v.trangThai !== 'da-dong'
  const huySoCu = v.laChu && v.soCu && v.sessionsUsed === 0
  return {
    tangBuoi: mo && v.batGoiVi,
    giaHan: mo,
    huySoCu: mo && huySoCu,
    hoanGoi: mo && !huySoCu,
  }
}
